import { render } from "./my-demande.vue?vue&type=template&id=3b66dcf4"
import script from "./my-demande.vue?vue&type=script&lang=js"
export * from "./my-demande.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__